import type { GraphViewPreviewable } from '@ipfabric/utils';
import { fetchViews } from 'components/Graph/commands/fetchViews';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface StarViewCommand {
  view: GraphViewPreviewable;
}

export const starView: GraphCommandFactory<StarViewCommand> =
  (cmdContext, dispatch) => async (command) => {
    try {
      cmdContext.updateState((draft) => {
        draft.loadViewDialog.viewIdsBeingStarred.add(command.view.id);
      });

      await cmdContext.api.request({
        url: `/graphs/views/${encodeURIComponent(command.view.id)}/favorite`,
        method: 'POST',
      });
    } finally {
      try {
        await dispatch(fetchViews);
      } finally {
        cmdContext.updateState((draft) => {
          draft.loadViewDialog.viewIdsBeingStarred.delete(command.view.id);
        });
      }
    }
  };
